module.exports = __webpack_public_path__ + "static/media/sigma-large-blue.dd1f5256.svg";